module.exports = __webpack_public_path__ + "static/media/ME-Thesis-template_Miktex.60a820bc.zip";